import { render, staticRenderFns } from "./recipients-modal-import-db.vue?vue&type=template&id=22db86c2&"
import script from "./recipients-modal-import-db.vue?vue&type=script&lang=js&"
export * from "./recipients-modal-import-db.vue?vue&type=script&lang=js&"
import style0 from "./recipients-modal-import-db.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports